/**
 * TURBO GATE — Core Engine 2026
 * JavaScript puro senza dipendenze esterne.
 */

document.addEventListener('DOMContentLoaded', () => {
    
    // --- 1. INIZIALIZZAZIONE ICONE ---
    if (typeof lucide !== 'undefined') {
        lucide.createIcons();
    }

    // --- 2. MENU MOBILE (BURGER) ---
    const burger = document.getElementById('burger-toggle');
    const nav = document.getElementById('mobile-menu');
    const navLinks = document.querySelectorAll('.nav__link');

    if (burger && nav) {
        const toggleMenu = () => {
            burger.classList.toggle('active');
            nav.classList.toggle('active');
            // Blocca lo scroll della pagina quando il menu è aperto
            document.body.style.overflow = nav.classList.contains('active') ? 'hidden' : '';
        };

        burger.addEventListener('click', toggleMenu);

        // Chiusura al click su una voce del menu
        navLinks.forEach(link => {
            link.addEventListener('click', () => {
                if (nav.classList.contains('active')) toggleMenu();
            });
        });
    }

    // --- 3. EFFETTO HEADER ALLO SCROLL ---
    const header = document.querySelector('.header');
    window.addEventListener('scroll', () => {
        if (window.scrollY > 50) {
            header?.classList.add('header--scrolled');
        } else {
            header?.classList.remove('header--scrolled');
        }
    });

    // --- 4. ANIMAZIONE DI COMPARSA (REVEAL ON SCROLL) ---
    const revealItems = document.querySelectorAll('.reveal');
    
    const revealObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('active');
            }
        });
    }, { threshold: 0.15 });

    revealItems.forEach(item => revealObserver.observe(item));

    // --- 5. GEOMETRIA TIMELINE (LINEA DI PROGRESSO) ---
    const progressLine = document.querySelector('.timeline__progress');
    const timelineSection = document.querySelector('.innovations');

    if (progressLine && timelineSection) {
        window.addEventListener('scroll', () => {
            const rect = timelineSection.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            
            // Calcolo: quando la parte superiore della sezione raggiunge la metà dello schermo
            let progress = (windowHeight / 2 - rect.top) / rect.height;
            progress = Math.min(Math.max(progress, 0), 1);
            
            progressLine.style.height = `${progress * 100}%`;
        });
    }

    // --- 6. HERO: CANVAS INTERATTIVO (RETE NEURALE) ---
    const canvas = document.getElementById('hero-canvas');
    if (canvas) {
        const ctx = canvas.getContext('2d');
        let particles = [];
        const mouse = { x: -1000, y: -1000 };

        window.addEventListener('mousemove', (e) => {
            mouse.x = e.clientX;
            mouse.y = e.clientY;
        });

        class Particle {
            constructor() {
                this.init();
            }
            init() {
                this.x = Math.random() * canvas.width;
                this.y = Math.random() * canvas.height;
                this.speedX = (Math.random() - 0.5) * 0.5;
                this.speedY = (Math.random() - 0.5) * 0.5;
            }
            update() {
                this.x += this.speedX;
                this.y += this.speedY;
                if (this.x > canvas.width || this.x < 0) this.speedX *= -1;
                if (this.y > canvas.height || this.y < 0) this.speedY *= -1;
            }
            draw() {
                ctx.fillStyle = 'rgba(0, 198, 255, 0.3)'; // Colore Turbo Gate
                ctx.beginPath();
                ctx.arc(this.x, this.y, 2, 0, Math.PI * 2);
                ctx.fill();
            }
        }

        function setupCanvas() {
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
            particles = Array.from({ length: 80 }, () => new Particle());
        }

        function renderCanvas() {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            particles.forEach((p, i) => {
                p.update();
                p.draw();
                for (let j = i; j < particles.length; j++) {
                    const dx = p.x - particles[j].x;
                    const dy = p.y - particles[j].y;
                    const dist = Math.sqrt(dx * dx + dy * dy);
                    if (dist < 120) {
                        ctx.strokeStyle = `rgba(0, 114, 255, ${1 - dist / 120})`; // Gradiente Turbo Gate
                        ctx.lineWidth = 0.5;
                        ctx.beginPath();
                        ctx.moveTo(p.x, p.y);
                        ctx.lineTo(particles[j].x, particles[j].y);
                        ctx.stroke();
                    }
                }
            });
            requestAnimationFrame(renderCanvas);
        }

        window.addEventListener('resize', setupCanvas);
        setupCanvas();
        renderCanvas();
    }

    // --- 7. EFFETTO SPOTLIGHT PER LE CARD ---
    const cards = document.querySelectorAll('.benefit-card');
    cards.forEach(card => {
        card.addEventListener('mousemove', (e) => {
            const rect = card.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;
            card.style.setProperty('--mouse-x', `${x}px`);
            card.style.setProperty('--mouse-y', `${y}px`);
        });
    });

    // --- 8. MODULO DI CONTATTO CON CAPTCHA ---
    const form = document.getElementById('ai-contact-form');
    if (form) {
        const phoneInput = document.getElementById('phone');
        const captchaText = document.getElementById('captcha-question');
        const captchaInput = document.getElementById('captcha');
        const successMsg = document.getElementById('form-success');
        let currentAnswer;

        const refreshCaptcha = () => {
            const a = Math.floor(Math.random() * 10) + 1;
            const b = Math.floor(Math.random() * 10) + 1;
            currentAnswer = a + b;
            if (captchaText) captchaText.textContent = `${a} + ${b} = ?`;
        };

        refreshCaptcha();

        // Validazione telefono (solo numeri e simboli base)
        phoneInput?.addEventListener('input', (e) => {
            e.target.value = e.target.value.replace(/[^\d\+\-\s]/g, '');
        });

        form.addEventListener('submit', async (e) => {
            e.preventDefault();

            if (parseInt(captchaInput.value) !== currentAnswer) {
                alert('Per favore, risolvi correttamente l\'operazione matematica.');
                refreshCaptcha();
                captchaInput.value = '';
                return;
            }

            const btn = form.querySelector('.form__submit');
            const originalText = btn.textContent;
            btn.textContent = 'Invio in corso...';
            btn.disabled = true;

            // Simulazione ritardo di rete (AJAX)
            await new Promise(r => setTimeout(r, 1500));

            form.reset();
            refreshCaptcha();
            btn.textContent = originalText;
            btn.disabled = false;
            
            if (successMsg) {
                successMsg.style.display = 'flex';
                if (typeof lucide !== 'undefined') lucide.createIcons();
                setTimeout(() => { successMsg.style.display = 'none'; }, 5000);
            }
        });
    }

    // --- 9. POPUP COOKIE ---
    const cookieBox = document.getElementById('cookie-popup');
    const cookieBtn = document.getElementById('cookie-accept');

    // Chiave aggiornata per Turbo Gate
    if (cookieBox && !localStorage.getItem('turbo_gate_cookies')) {
        setTimeout(() => {
            cookieBox.classList.add('active');
        }, 3000);
    }

    cookieBtn?.addEventListener('click', () => {
        localStorage.setItem('turbo_gate_cookies', 'true');
        cookieBox.classList.remove('active');
    });
});